import { UserAvatar } from "@promptlayer/ui";
import * as React from "react";

interface UserHeaderProps {
  email: string;
  userRole: string;
}

export const UserHeader: React.FC<UserHeaderProps> = ({ email, userRole }) => (
  <div className="border-b border-gray-100 bg-gray-50/50 px-3 py-3">
    <div className="flex items-center gap-2.5">
      <UserAvatar email={email} className="h-8 w-8" />
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-medium text-gray-900">{email}</p>
        <p className="text-xs text-gray-500">{userRole}</p>
      </div>
    </div>
  </div>
);
